import { Desktop, devices } from "@/utils/breakpoints"
import React, {
  RefObject,
  useEffect,
  useRef,
  useState,
} from "react"
import styled from "styled-components"

const Relative = styled.div`
  position: relative;
`

const Container = styled.div<{
  fixed: boolean
  top: number
}>`
  position: ${(props) =>
    props.fixed ? "fixed" : "absolute"};
  top: ${(props) => props.top}px;
`

const Phony = styled.div`
  @media ${devices.desktop} {
    visibility: hidden;
  }
`

interface PinnedMenuProps {
  container: RefObject<HTMLDivElement>
  children: React.ReactNode
}

const PinnedMenu = (props: PinnedMenuProps) => {
  const { children, container } = props

  const [fixed, setFixed] = useState(true)
  const [top, setTop] = useState(0)

  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const onScroll = () => {
      const parent = container.current
      if (parent === null) return
      const doc = document.scrollingElement
      if (doc === null) return
      const current = ref.current
      if (current === null) return

      const absolutePosition =
        parent.clientHeight - current.clientHeight
      const fixedPosition = parent.offsetTop
      const shouldBeFixed =
        doc.scrollTop + current.clientHeight <
        parent.clientHeight

      if (shouldBeFixed) {
        if (!fixed) setFixed(true)
        if (top !== fixedPosition) setTop(fixedPosition)
      } else {
        if (fixed) setFixed(false)
        if (top !== absolutePosition)
          setTop(absolutePosition)
      }
    }

    onScroll()

    addEventListener("scroll", onScroll)

    return () => removeEventListener("scroll", onScroll)
  }, [fixed, setFixed, top, setTop, container, ref])

  return (
    <Relative>
      <Desktop>
        <Container fixed={fixed} top={top}>
          {children}
        </Container>
      </Desktop>
      <Phony ref={ref}>{children}</Phony>
    </Relative>
  )
}

export default PinnedMenu
